import clsx from 'clsx';
import React from 'react';

import CommonTooltip from '../../../../components/common-tooltip/CommonTooltip';

import scss from './SlideButton.module.scss';

function SlideButton({ icon: IconComponent, onClick, disabled, ariaLabel, className, tooltip }) {
  return (
    <CommonTooltip title={tooltip}>
      <button
        type='button'
        className={clsx(scss.wrapper, disabled && scss.disabled, className)}
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}>
        <IconComponent />
      </button>
    </CommonTooltip>
  );
}

export default SlideButton;
